import { Directive, HostBinding, ContentChildren, Input, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';

import { ZoomImageService } from '../../services/zoomImage/zoom-image.service';

//  Headline Directive
@Directive({
  selector: '[dlsHeadline], dls-headline',
  exportAs: 'dlsHeadline'
})
export class HeadlineDirective {

  @HostBinding('class.dls-headline') headlineClass: boolean;

  constructor() {
    this.headlineClass = true;
  }
}

//  Title Directive
@Directive({
  selector: '[dlsTitle], dls-title',
  exportAs: 'dlsTitle'
})
export class TitleDirective {

  @HostBinding('class.dls-title') titleClass: boolean;
  @HostBinding('class.mat-body') matBodyClass: boolean;
  @HostBinding('class.mb-0') mb0Class: boolean;

  constructor() {
    this.titleClass = true;
    this.matBodyClass = true;
    this.mb0Class = true;
  }
}

//  Body Directive
@Directive({
  selector: '[dlsBody], dls-body',
  exportAs: 'dlsBody'
})
export class BodyDirective {

  @HostBinding('class.dls-body') bodyClass: boolean;
  @HostBinding('class.mat-body') matBodyClass: boolean;
  @HostBinding('class.mb-0') mb0Class: boolean;

  constructor() {
    this.bodyClass = true;
    this.matBodyClass = true;
    this.mb0Class = true;
  }

}

//  Img Directive
@Directive({
  selector: 'img[dlsImg], img[dls-img]',
  exportAs: 'dlsImg'
})
export class ImgDirective implements AfterViewInit, OnDestroy {

  @HostBinding('class.dls-img') imgClass: boolean;
  @HostBinding('class.w-100') w100Class: boolean;
  @HostBinding('style.width') widthStyle: string;

  @HostBinding('style.max-width') maxWidth: string;

  private _isZoomable: boolean;
  @Input()
  public get isZoomable(): boolean { return this._isZoomable; }
  public set isZoomable(value: boolean) {
    this._isZoomable = value;
    /**
     * Attaches and detaches native element to zoom image service
     */
    if (value) {
      this.zoomImageService.attachImage(this.el.nativeElement);
    } else {
      this.zoomImageService.detachImage(this.el.nativeElement);
    }
  }

  @Input()
  set width(width: string) {
    // Image width
    if (width) {
      // Remove 100% width
      this.w100Class = false;
      // Add custom width
      this.widthStyle = width;
    } else {
      this.w100Class = true;
    }
  }

  constructor(private el: ElementRef, private zoomImageService: ZoomImageService) {
    this.imgClass = true;
    this.w100Class = true;

    /**
     * Attaches nativeElement to zoom by default
     */
    this.zoomImageService.attachImage(this.el.nativeElement);
  }

  ngAfterViewInit(): void {
    // Set max width to natural height & width
    this.el.nativeElement['onload'] = (event) => {
      this.maxWidth = `${this.el.nativeElement['naturalWidth']}px`;
    };
  }

  ngOnDestroy(): void {
    if (this.isZoomable) {
      // Detaches the current nativeElement from zoom service
      this.zoomImageService.detachImage(this.el.nativeElement);
    }
  }
}
